import createValidator from 'typecheck.macro';
import { makeExperimentWithData } from '../../common/ExperimentContext/types';

export const DentalSpecialtyMessageExperiment = (isMobile: boolean) =>
  !isMobile
    ? makeExperimentWithData(
        'TPL-InfoBox-DentalSERP',
        createValidator<
          | undefined
          | {
              title: string;
              body: string;
            }
        >(),
      )
    : null;
